export const itExists = (item, ...items) => {
	let allItems = [ item, ...items ];
	if (allItems.length === 0) return false;
	const result = allItems.every(
		(item) => String(item) !== "undefined" && String(item) !== "NaN" && String(item) !== "null" && item !== "",
	);
	return result;
};
